module.exports = __webpack_public_path__ + "img/icon-step-2-summary-payment.9225a108.svg";